/**
 * Product page preload. These three mount above the fold on the PDP but are registered
 * through AsyncAlpine in theme.js so their chunks are only requested once theme.js has
 * downloaded and run.
 */
import variantPicker from "../js/components/variant-picker.js";
import colorSwitcher from "../js/components/color-switcher.js";
import scrollImageFallback from "../js/components/scroll-image-fallback.js";

document.addEventListener("alpine:init", () => {
  window.Alpine.data("variantPicker", variantPicker);
  window.Alpine.data("colorSwitcher", colorSwitcher);
  window.Alpine.data("scrollImageFallback", scrollImageFallback);
});
